import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const baseStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    backgroundColor: "var(--color-cool-ash)",
    color: "var(--color-pure-white)",
    padding: "6px 12px",
    borderRadius: 1000,
    fontFamily: "var(--font-display)",
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    lineHeight: 1,
    whiteSpace: "nowrap",
    userSelect: "none",
};
export function SimulatedPill({ label = "Simulated", style, testId = "simulated-pill", }) {
    return (_jsxs("span", { style: { ...baseStyle, ...style }, "data-testid": testId, "aria-label": `${label} data feed`, children: [_jsx("span", { "aria-hidden": "true", style: {
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    backgroundColor: "var(--color-pure-white)",
                    opacity: 0.85,
                } }), label] }));
}
